import { render } from "./CommentSvg.vue?vue&type=template&id=3fdbd03d&scoped=true"
import script from "./CommentSvg.vue?vue&type=script&lang=ts"
export * from "./CommentSvg.vue?vue&type=script&lang=ts"

import "./CommentSvg.vue?vue&type=style&index=0&id=3fdbd03d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3fdbd03d"

export default script